<!--
  商城购买商品时地址为这样 展示为仅现金卡
  /web/select-card-pay?orderMode=1&goodsType=GENERAL_GOODS&cateId=118&topicId=0
-->

<template>
  <div class="cart-page-2">
    <van-notice-bar v-if="requireWxPayTotal > 0" left-icon="info-o" mode="closeable">
      特殊商品，购买前阅读注意事项
    </van-notice-bar>

    <van-notice-bar v-if="timesCardPayMode === 2" left-icon="info-o" mode="closeable">
      特殊电影，需多张次票兑换
    </van-notice-bar>

    <!-- 选择支付方式 -->
    <div style="margin: 16px">
      <van-radio-group v-model="movieTimesPayType" @change="movieTimesPayTypeChange">
        <van-cell v-if="timesCardPayMode === 2 || timesCardPayMode === 3" :border="false" clickable
          label="1张电影票消耗1张次卡,超过限额使用多张次卡兑换" style="background-color: #fefbea; border: solid 1px #f7d204"
          title="次卡多兑一 多用券 少花钱" @click="radio = '1'">
          <template #right-icon>
            <van-radio name="1" />
          </template>
        </van-cell>

        <van-cell v-if="timesCardPayMode === 2" :border="false" :label="'电影票可使用现金卡券抵扣,超过限额支持微信支付补差'" clickable
          class="budo-32" style="
            margin-top: 8px;
            background-color: #fefbea;
            border: solid 1px #f7d204;
          " title="现金卡抵扣" @click="radio = '2'">
          <template #right-icon>
            <van-radio name="2" />
          </template>
        </van-cell>

        <van-cell v-if="timesCardPayMode === 3" :border="false" clickable label="1张电影票消耗1张次卡,超过限额支持微信支付补差" style="
            background-color: #fefbea;
            margin-top: 8px;
            border: solid 1px #f7d204;
          " title="次卡一兑一 使用灵活" @click="radio = '3'">
          <template #right-icon>
            <van-radio name="3" />
          </template>
        </van-cell>

        <!-- 武侯模式 仅使用现金卡 不使用次卡支付 movieTimesPayType 赋值为 4 -->
        <!-- 没有现金卡就不展示 -->
        <van-cell v-if="timesCardPayMode === 3 && moneyCards && moneyCards.length > 0" class="budo-53" :border="false"
          clickable label="使用现金卡券抵扣,超过限额支持微信补差" style="
            background-color: #fefbea;
            margin-top: 8px;
            border: solid 1px #f7d204;
          " title="现金卡抵扣" @click="radio = '4'">
          <!-- movieTimesPayTypeChange -->
          <template #right-icon>
            <van-radio class="budo-51" name="4" />
          </template>
        </van-cell>
      </van-radio-group>
    </div>

    <!-- 列出所有卡 勾选 -->
    <div style="background-color: #e9e9e9; margin: 16px">
      <van-checkbox-group v-model="selectedCardIds" @change="onSelectedCardIdsChange">
        <van-cell-group>
          <!-- 如果武侯模式用户选择现金卡抵扣 就不展示次卡部分 -->
          <template v-if="movieTimesPayType != '4' && can_use_time_card()">
            <van-cell v-if="timesCards && timesCards.length > 0" style="background-color: #f7f8fa">
              <template #title>
                <div style="display: flex; align-items: center">
                  <span style="font-weight: bold">次卡抵扣</span>
                </div>
              </template>
              <template #right-icon>
                <div v-if="!isPackageGoods" style="display: flex; align-items: center">
                  <img :src="`${publicPath}images/user-center/cion.png`" style="width: 25px; height: 25px" />
                  <span style="font-weight: bold; margin-left: 8px">{{ minusMoneyTotalByTimes | money }}</span>
                </div>
              </template>
            </van-cell>

            <!-- 次卡 -->
            <van-cell v-for="(item, idx) in timesCards" :key="item.cardKey" :center="true" :title="`${item.name}`"
              clickable>
              <template #label>
                <span>余额: {{ item.quantity }} 次 </span>
                <span v-if="item.displayConvertFlag && !isPackageGoods">
                  兑换上限: {{ (isMovieOrder ? item.goodsPrice : item.convertMoney) | money }}
                </span>
                <!-- 界面上不展示 -->
                <span style="display: none" v-if="item.orderFeeThreshold">使用门槛: {{ item.orderFeeThreshold }}</span>
              </template>
              <template #right-icon>
                <van-row>
                  <van-col>
                    <van-tag v-if="selectedCardIds.indexOf(item.cardKey) >= 0" round style="
                        margin-right: 10px;
                        height: 18px;
                        display: flex;
                        align-items: center;
                        line-height: 100%;
                      " type="danger"> 次卡使用 {{ item.useQuantity }} 次
                    </van-tag>
                  </van-col>
                  <van-col>
                    <van-checkbox class="budo-100" :disabled="disabled_time_cards(item, idx)" :name="item.cardKey"
                      label-disabled />
                  </van-col>
                </van-row>
              </template>
            </van-cell>
          </template>

          <van-cell v-if="selectedTimesCount > 0 && movieServiceFee > 0">
            <van-notice-bar background="#ecf9ff" color="#1989fa" left-icon="info-o">
              需支付超长电影升级服务费：{{ movieServiceFee | money }} 元
            </van-notice-bar>
          </van-cell>

          <!-- 现金卡抵扣 没有现金卡就不展示 -->
          <van-cell style="background-color: #f7f8fa" class="budo-124" v-if="moneyCards && moneyCards.length > 0">
            <template #title>
              <div style="display: flex; align-items: center">
                <span style="font-weight: bold">现金卡抵扣</span>
              </div>
            </template>
            <template #right-icon>
              <div style="display: flex; align-items: center">
                <img :src="`${publicPath}images/user-center/cion.png`" style="width: 25px; height: 25px" />
                <span style="font-weight: bold; margin-left: 8px">{{ minusMoneyTotalByMoney | money }}</span>
              </div>
            </template>
          </van-cell>

          <van-cell v-for="item in moneyCards" :key="item.cardKey" :center="true"
            :title="`${item.name}${item.zoneId > 0 ? '(' + item.zoneId + ')' : ''}`" clickable>
            <template #label> 余额: {{ item.quantity | money }}</template>
            <template #right-icon>
              <van-row>
                <van-col>
                  <van-tag v-if="selectedCardIds.indexOf(item.cardKey) >= 0" round style="
                      margin-right: 10px;
                      height: 18px;
                      display: flex;
                      align-items: center;
                      line-height: 100%;
                      padding: 0 8px;
                    " type="danger">
                    现金卡使用 {{ item.useQuantity | money }}
                  </van-tag>
                </van-col>
                <van-col>
                  <van-checkbox class="budo-143" :disabled="disabled_money_cards(item)" :name="item.cardKey"
                    label-disabled />
                </van-col>
              </van-row>
            </template>
          </van-cell>
          <!-- 现金卡抵扣结束 -->
        </van-cell-group>
      </van-checkbox-group>
    </div>

    <van-empty />

    <!-- 底部条 -->
    <div class="box4 flex-row col-center row-between">
      <div class="flex-row" style="margin-left: 4px; line-height: 40px">
        <div v-if="!isPackageGoods">
          <div v-if="movieTimesCardUseCount > 0 && movieTimesPayType === '1'" class="budo-locator-125">
            <span class="ml4 budo-163" style="font-size: 12px; color: #666666; line-height: 40px">待支付</span>
            <span v-if="movieTimesCardWaitPayTotal > 0" style="font-size: 20px; margin-left: 5px">
              {{ movieTimesCardWaitPayTotal }} 次
            </span>
            <span v-if="requireWxPayTotal > 0 && movieTimesCardWaitPayTotal > 0"
              style="color: #f00; font-size: 16px; font-weight: bold">+</span>
            <span v-if="requireWxPayTotal > 0" style="font-size: 20px; margin-left: 5px">
              {{ requireWxPayTotal | money }} 豆
            </span>
          </div>

          <!-- 武侯模式 次卡 + 现金卡 -->
          <div v-else-if="movieTimesPayType === '3'" class="budo-locator-136">
            <span class="ml4 budo-176" style="font-size: 12px; color: #666666; line-height: 40px">待支付</span>
            <span style="font-size: 20px; margin-left: 5px; margin-right: 5px">
              {{ movieTimesCardWaitPayTotal }} 次
            </span>
            <span style="color: #f00; font-size: 16px; font-weight: bold">+</span>
            <span style="font-size: 20px; margin-left: 5px">
              {{ (wait_pay_total + requireWxPayTotal) | money }} 豆
            </span>
          </div>

          <!-- 武侯模式 用户选择仅现金卡支付 -->
          <div v-else-if="movieTimesPayType === '4'" class="budo-locator-159">
            <span class="ml4 budo-188" style="font-size: 12px; color: #666666; line-height: 40px">待支付</span>
            <img :src="`${publicPath}images/user-center/cion.png`" style="
                width: 25px;
                height: 25px;
                margin-top: 5px;
                margin-left: 10px;
              " />
            <span style="font-size: 20px; margin-left: 5px">
              {{ (wait_pay_total + requireWxPayTotal) | money }}
            </span>
          </div>

          <div v-else class="budo-locator-142">
            <span class="ml4 budo-199" style="font-size: 12px; color: #666666; line-height: 40px">待支付</span>
            <img :src="`${publicPath}images/user-center/cion.png`" style="
                width: 25px;
                height: 25px;
                margin-top: 5px;
                margin-left: 10px;
              " />
            <span style="font-size: 20px; margin-left: 5px">
              {{ (wait_pay_total + requireWxPayTotal) | money }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div v-if="!allowPay()" class="text-center ml4 card-btn">请选择卡券</div>
        <div v-else class="text-center ml4 card-btn-345" @click="createOrder">创建订单</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mall_orders_create,
  mall_wx_goods_get_movie_by_tradeno,
  mall_wx_orders_get_movie_service_fee,
} from "@/api/goods-api";
import { api_get_bind_cards } from "@/api/user";
import store from "@/store/index";
import { Dialog, Notify, Toast } from "vant";

import {
  CARD_TYPE,
  GOODS_CATE_INFO,
  GOODS_TYPE_DU_MOVIE,
  ORDER_TYPE_HEALTH,
  ORDER_TYPE_HW_H5,
  ORDER_TYPE_JDJL,
  ORDER_TYPE_WDG,
  ORDER_TYPE_YHCS,
} from "@/api/constant";

import { mall_wx_get_user_info } from "@/api/login";
import { mall_util_order_buy_goods } from "@/util/orders";
import { RC_order_info_for_pay } from "./rc-order-util";

import { get_hw_h5_order, hw_h5_order_info_for_pay } from "./hw-h5-order";
import { JDJL_get_order, JDJL_order_info_for_pay } from "./JDJL_order";
import { Qipiao_get_order, Qipiao_order_info_for_pay } from "./Qipiao_order";
import { shoutu_show_h5_get_order, shoutu_show_h5_order_info_for_pay } from "./shoutu_show_h5_order";
import { WDG_get_order, WDG_order_info_for_pay } from "./WDG_order";
import { YHCS_get_order, YHCS_order_info_for_pay } from "./YHCS_order";
import { ORDER_INFO_CACHE_KEY } from "@/util/XiZhangUtil"

export default {
  name: "select-card-pay",

  data() {
    return {
      publicPath: process.env.BASE_URL,
      userCards: [], // 用户已绑定卡券 {cardId,name,type,quantity,displayConvertFlag,convertMoney,goodsPrice,banCateIds}
      timesCards: [], // 次卡支付 {cardId,quantity,useQuantity,}
      moneyCards: [], // 现金卡支付 {cardId,quantity,useQuantity,}

      wait_pay_total: 0, // 待支付总金额，单位：分
      minusMoneyTotal: 0, // 抵扣的总金额 分
      minusMoneyTotalByTimes: 0, // 抵扣的总金额 分
      minusMoneyTotalByMoney: 0, // 抵扣的总金额 分
      selectedCardIds: [], // 已选择的id

      payTotal: 0, // 支付总金额，单位：分
      orderType: GOODS_CATE_INFO.general.id, // 电影（次卡和现金卡），礼包（次卡），其它（现金卡）
      isPackageGoods: true, // 打包商品只允许次卡，不补差，不能用现金卡
      orderMode: 0,
      movieTicketCount: 0, // 电影票数量
      selectedTimesCount: 0, // 已选择次卡次数
      isMovieOrder: false,

      topicId: 0, // 专题编号
      requireWxPayTotal: 0, // 必须微信支付的金额,

      movieTimesCardUseCount: 0, // 电影次卡使用数量
      movieTimesCardPayTotal: 0, // 待支付的次数
      movieTimesCardWaitPayTotal: 0, // 待支付次数
      movieTimesPayType: "1",
      timesCardPayMode: 1, // 业务逻辑: 1 = 1次卡 + 补差; 2 = 固定次卡数; 3 = 次卡数 + 补差
      payModeInfo: [],
      movieServiceFee: 0,

      movieByTradeno: {},
    };
  },

  created() {
    if (ORDER_TYPE_HW_H5 == this.$route.query.goodsType) {
      // 海威点餐订单 先根据参数拿数据 再执行
      get_hw_h5_order(this.$route.query.tradeno).then((res) => {
        var cacheKey = ORDER_INFO_CACHE_KEY;
        sessionStorage.setItem(cacheKey, JSON.stringify(res));
        this._on_created_();
      });

      return;
    }

    if (ORDER_TYPE_JDJL == this.$route.query.goodsType) {
      // 京东锦礼订单 先根据参数拿到订单数据
      JDJL_get_order(this.$route.query.JDJL_orderId).then((res) => {
        var cacheKey = ORDER_INFO_CACHE_KEY;
        sessionStorage.setItem(cacheKey, JSON.stringify(res));
        this._on_created_();
      });

      return;
    }

    if (ORDER_TYPE_YHCS == this.$route.query.goodsType) {
      // 京东锦礼订单 先根据参数拿到订单数据
      YHCS_get_order(this.$route.query.YHCS_tradeNo).then((res) => {
        var cacheKey = ORDER_INFO_CACHE_KEY;
        sessionStorage.setItem(cacheKey, JSON.stringify(res));
        this._on_created_();
      });

      return;
    }

    if (ORDER_TYPE_WDG == this.$route.query.goodsType) {
      WDG_get_order(this.$route.query.WDG_order_sns).then((res) => {
        var cacheKey = ORDER_INFO_CACHE_KEY;
        sessionStorage.setItem(cacheKey, JSON.stringify(res));
        this._on_created_();
      });

      return;
    }

    if ("goodsType_qipiao_0" == this.$route.query.goodsType
      || "goodsType_qipiao_1" == this.$route.query.goodsType
      || "goodsType_qipiao_5" == this.$route.query.goodsType) {
      Qipiao_get_order(this.$route.query.qipiao_order_id, this.$route.query.goodsType).then((res) => {
        var cacheKey = ORDER_INFO_CACHE_KEY;
        sessionStorage.setItem(cacheKey, JSON.stringify(res));
        this._on_created_();
      });
      return;
    }

    if ("shoutu_h5" == this.$route.query.goodsType) {
      shoutu_h5_get_order(this.$route.query.shoutu_orderNo).then((res) => {
        var cacheKey = ORDER_INFO_CACHE_KEY;
        sessionStorage.setItem(cacheKey, JSON.stringify(res));
        this._on_created_();
      });
      return
    }

    // 其他订单 前一个步骤已传入订单信息 直接执行
    this._on_created_();
  },

  methods: {
    can_use_time_card() {
      var orderInfo = this._get_orderInfo_();
      if (
        orderInfo?.goodsList?.length > 0 &&
        orderInfo?.goodsList[0]?.goods?.supplierId == 321
      ) {
        // 蛋糕叔叔 不用次卡
        budo_log.info("#338 can_use_time_card false", orderInfo);
        return false;
      }

      budo_log.debug("#342 can_use_time_card true", orderInfo);
      return true;
    },

    _on_created_() {
      // 单个商品购买模式
      this.orderMode = parseInt(this.$route.query.orderMode || 0, 10);

      // 订单类型
      if (!this.$route.query.goodsType) {
        Notify("订单类型参数必须");
        return;
      }

      this.cateId = parseInt(this.$route.query.cateId || 1, 10);
      this.topicId = parseInt(this.$route.query.topicId || 0, 10);

      var orderInfo = this._get_orderInfo_();

      budo_log.debug("#313 _on_created_, orderInfo=", orderInfo);

      // 如果电影
      if (this.cateId === GOODS_CATE_INFO.movie.id) {
        this.movieTicketCount = orderInfo.goodsList[0].count;
        const tradeno = orderInfo.tradeno;

        budo_log.info("#302 before mall_wx_goods_get_movie_by_tradeno, tradeno=", tradeno);

        mall_wx_goods_get_movie_by_tradeno(tradeno).then((res) => {
          budo_log.debug("#305 resp mall_wx_goods_get_movie_by_tradeno, tradeno=", tradeno, "res.data=", res.data);

          if (res.code !== 0) {
            Dialog({
              message: res.msg,
            }).then(() => {
              this.$router.replace({
                path: "order-list",
                query: { orderType: "movie" },
              });
            });
          } else {
            this.movieByTradeno = res.data; // 存一下 后面用

            if (res.data.useCountCard > 0 || res.data.payMode > 1) {
              // 业务逻辑 1 = 1次卡 + 补差 2 = 固定次卡数 3 = 次卡数 + 补差
              this.timesCardPayMode = res.data.useCountCard > 0 ? 2 : res.data.payMode;

              budo_log.info("#314 timesCardPayMode=", this.timesCardPayMode, "res.data=", res.data);

              if (this.timesCardPayMode === 3) {
                this.payModeInfo = res.data.payModeInfo;

                // 不补差需要的次卡数量
                const noPatch = JSON.parse(
                  JSON.stringify(this.payModeInfo)
                ).filter((info) => info.isPatch === false)[0];
                this.movieTimesCardUseCount = noPatch.timeCardCount;

                budo_log.info("#342 movieTimesCardPayTotal=" + this.movieTimesCardPayTotal + //
                  ", movieTimesCardWaitPayTotal=" + this.movieTimesCardWaitPayTotal + ", movieTimesCardUseCount=" + this.movieTimesCardUseCount);
                this.movieTimesCardPayTotal = this.movieTimesCardWaitPayTotal = this.movieTimesCardUseCount;

                this.wait_pay_total = 0;

                // 不补差需要的次卡数量
                this.selectedTimesCount = 0;
                this.disabledMoneyCards();
              } else if (this.timesCardPayMode === 2) {
                // 电影次卡使用数量
                this.movieTimesCardUseCount = res.data.useCountCard;

                // 待支付次数
                budo_log.info("#356 movieTimesCardPayTotal=" + this.movieTimesCardPayTotal + //
                  ", movieTimesCardWaitPayTotal=" + this.movieTimesCardWaitPayTotal + ", movieTimesCardUseCount=" + this.movieTimesCardUseCount);

                this.movieTimesCardPayTotal = this.movieTimesCardWaitPayTotal =
                  this.movieTimesCardUseCount * this.movieTicketCount;
              }
            }

            // 电影服务费
            mall_wx_orders_get_movie_service_fee(
              res.data.moviename,
              res.data.quantity
            ).then((feeData) => {
              this.movieServiceFee = feeData.data;
            });
          }

          // timesCardPayMode == 3 界面似乎没生效 强制重新渲染 以下
          this.$forceUpdate();
        });
      }
      // 如果电影结束

      // 商品
      budo_log.debug("#363 orderInfo=", orderInfo);
      var _goodsList_ = orderInfo && orderInfo.goodsList ? orderInfo.goodsList : [];

      this.requireWxPayTotal = _goodsList_
        .filter((g) => g.checked) //
        .map((g) => g.goods.payWxMin * g.count) //
        .reduce((a, b) => {
          return a + b;
        }, 0);

      if (!this.requireWxPayTotal) {
        this.requireWxPayTotal = 0;
      }

      this.orderType = orderInfo.goodsType;
      this.isMovieOrder = this.orderType === GOODS_TYPE_DU_MOVIE;
      this.isPackageGoods = orderInfo.isPackageGoods || false;

      this.payTotal = orderInfo.orderFee - this.requireWxPayTotal;

      this.wait_pay_total = orderInfo.orderFee - this.requireWxPayTotal;

      budo_log.debug("#369 wait_pay_total=", this.wait_pay_total, ", payTotal=", this.payTotal, "orderInfo.orderFee=", orderInfo.orderFee);

      var tradeno = this._get_orderInfo_().tradeno;

      // 当前用户的所有卡
      api_get_bind_cards(
        this.$store.getters.city_code,
        this.cateId,
        this.topicId,
        tradeno
      ).then((res) => {
        budo_log.debug("#417 api_get_bind_cards", res);

        if (!res || !res.data || res.data.length < 1) {
          Dialog.alert({ message: "用户没有可用卡券" });
          return;
        }

        this.userCards = res.data.map((card) => {
          return {
            cardId: card.cardId,
            quantity: card.quantity, //余额
            useQuantity: 0, //使用金额,分
            minusMoney: 0, //抵扣金额，分
            cardType: card.type,
            displayConvertFlag: card.displayConvertFlag,
            goodsPrice: card.goodsPriceOfHall, // 为影厅设置的价格
            zoneId: card.zoneId,
            cardZoneId: card.cardZoneId,
            name: card.name,
            useType: card.type,
            convertMoney: card.convertMoney,
            orderFeeThreshold: card.orderFeeThreshold,
            // cardKey: 卡券唯一标识，当 zoneId 存在时为 "cardId_zoneId"，否则等于 cardId
            // 线上环境 zoneId 极少出现，绝大多数情况下 cardKey === cardId
            cardKey:
              card.zoneId && card.zoneId > 0
                ? card.cardId + "_" + card.zoneId
                : card.cardId,
          };
        });

        // 次卡和现金卡
        this.timesCards = this.userCards.filter((c) => c.cardType === 2);
        this.moneyCards = this.userCards.filter((c) => c.cardType === 1);

        // 自动选中第一张有门槛的 满减卡
        setTimeout(this.auto_select_manjian_cards, 500);
      });
    },

    // 如果选中了一张满减卡 不管手动还是自动 其他的满减卡就禁用了
    // 如果取消选中 应该自动回复
    if_select_other_threshold(cardInfo) {
      // budo_log.info("#460 if_select_other_threshold", cardInfo)

      // 选中的满减卡
      // 注：此处用 c.cardId 匹配 selectedCardIds，因线上 zoneId 极少出现，cardId === cardKey
      var selected_timesCards_Threshold = this.timesCards.filter(
        (c) =>
          this.selectedCardIds.indexOf(c.cardId) > -1 &&
          c.orderFeeThreshold &&
          c.orderFeeThreshold > 0
      );
      var selected_moneyCards_Threshold = this.moneyCards.filter(
        (c) =>
          this.selectedCardIds.indexOf(c.cardId) > -1 &&
          c.orderFeeThreshold &&
          c.orderFeeThreshold > 0
      );

      if (
        selected_timesCards_Threshold.length > 0 ||
        selected_moneyCards_Threshold.length > 0
      ) {
        // budo_log.info("#455 已有已选中的满减卡, 禁用其他满减卡 selected_timesCards_Threshold=", selected_timesCards_Threshold, "selected_moneyCards_Threshold=", selected_moneyCards_Threshold, "cardInfo=", cardInfo)
        return this.selectedCardIds.indexOf(cardInfo.cardId) < 0; // 如果已选择了满减卡 就将本张以外的其他满减卡 禁用
        // 注：此处用 cardId，因线上 zoneId 极少出现，cardId === cardKey
      }

      // 其他的返回 false 不禁用 可使用
      return false;
    },

    // 自动选中满减卡
    // 注：此处用 cardId 设置 selectedCardIds，因线上 zoneId 极少出现，cardId === cardKey
    auto_select_manjian_cards() {
      const orderInfo = this._get_orderInfo_();
      // budo_log.info("#463 auto_select_manjian_cards, orderInfo=", orderInfo);

      // 电影不搞自动选中满减卡
      if ("DU_MOVIE" == orderInfo.goodsType) {
        return;
      }

      for (var i = 0; i < this.timesCards.length; i++) {
        var tc = this.timesCards[i];
        if (
          tc.orderFeeThreshold &&
          tc.orderFeeThreshold > 0 &&
          tc.orderFeeThreshold <= orderInfo.orderFee
        ) {
          // 卡券设置的门槛必须小于当前订单金额
          budo_log.info("#451 自动选中 满减 次卡", tc, "orderInfo=", orderInfo);
          Toast("已自动选中优惠券");
          this.selectedCardIds = [tc.cardId];
          return;
        }
      }

      for (var j = 0; j < this.moneyCards.length; j++) {
        var mc = this.moneyCards[j];
        if (
          mc.orderFeeThreshold &&
          mc.orderFeeThreshold > 0 &&
          mc.orderFeeThreshold <= orderInfo.orderFee
        ) {
          // 卡券设置的门槛必须小于当前订单金额
          budo_log.info("#460 自动选中 满减 点卡", mc, "orderInfo=", orderInfo);
          Toast("自动选中优惠券");
          this.selectedCardIds = [mc.cardId];
          return;
        }
      }

      budo_log.debug("#458 没有自动选中优惠券, timesCards=", this.timesCards, "moneyCards=", this.moneyCards, "orderInfo=", orderInfo);
    },

    // 是否可支付
    allowPay() {
      if (this.selectedCardIds.length < 1) {
        budo_log.debug("#348 allowPay, selectedCardIds.length=", this.selectedCardIds.length);
        return false;
      }

      // movieTimesCardWaitPayTotal 待支付次数
      if (
        this.movieTimesCardWaitPayTotal > 0 &&
        this.movieTimesPayType === "1"
      ) {
        budo_log.debug("#337 allowPay, movieTimesCardWaitPayTotal=", this.movieTimesCardWaitPayTotal, "movieTimesPayType", this.movieTimesPayType);
        return false;
      }

      // movieTimesPayType 4 为 企业配置为武侯模式 用户选择了仅现金卡支付
      if (
        this.movieTimesCardWaitPayTotal > 0 &&
        this.movieTimesPayType !== "2" &&
        this.movieTimesPayType !== "4"
      ) {
        budo_log.info("#342 allowPay, movieTimesCardWaitPayTotal=", this.movieTimesCardWaitPayTotal, "movieTimesPayType", this.movieTimesPayType);
        return false;
      }

      budo_log.debug("#346 allowPay, movieTimesCardWaitPayTotal=", this.movieTimesCardWaitPayTotal, "movieTimesPayType", this.movieTimesPayType);
      return true;
    },

    // 获取订单信息 缓存一下
    _get_orderInfo_() {
      var orderInfo = this.$store.getters.orderInfo || {};
      var cacheKey = ORDER_INFO_CACHE_KEY;

      if (!orderInfo.goodsList) { // store 信息不对就从缓存中取
        orderInfo = JSON.parse(sessionStorage.getItem(cacheKey) || "{}");
      }

      if (!orderInfo.goodsList) {
        var _order_ = sessionStorage.getItem('rc-25-order_info')
        // console.log("#670 _get_orderInfo_", _order_)

        if (_order_) {
          orderInfo = JSON.parse(_order_).content
        }
      }

      if (orderInfo.goodsList) {
        sessionStorage.setItem(cacheKey, JSON.stringify(orderInfo)); // 对就缓存一手
      }

      // 网页刷新后 似乎会丢失这个 这里补一下
      if (!orderInfo.goodsType && this.$route.query.goodsType) {
        orderInfo.goodsType = this.$route.query.goodsType;
      }

      return orderInfo;
    },

    order_check() {
      let orderCheck = false;
      let orderInfo = this._get_orderInfo_();
      if (orderInfo) {
        if (
          ORDER_TYPE_HW_H5 == this.$route.query.goodsType ||
          ORDER_TYPE_JDJL == this.$route.query.goodsType ||
          ORDER_TYPE_YHCS == this.$route.query.goodsType ||
          ORDER_TYPE_WDG == this.$route.query.goodsType ||
          "goodsType_qipiao_0" == this.$route.query.goodsType ||
          "goodsType_qipiao_1" == this.$route.query.goodsType ||
          "goodsType_qipiao_5" == this.$route.query.goodsType ||
          "shoutu_h5" == this.$route.query.goodsType ||
          "TRAVEL_LYP" == this.$route.query.goodsType
        ) {
          orderCheck = true; // H5点餐 等 不验证 goodsList
        } else if (orderInfo.goodsType !== GOODS_CATE_INFO.movie.id) {
          if (orderInfo.goodsList && orderInfo.goodsList.length > 0) {
            orderCheck = true;
          } else {
            budo_log.info("#572 orderCheck false, goodsList empty, orderInfo", orderInfo);
            orderCheck = false;
          }
        } else {
          orderCheck = true;
        }
      } else {
        budo_log.info("#579 orderCheck false, no orderInfo", orderInfo);
        orderCheck = false;
      }

      return orderCheck;
    },

    // 点击创建订单按钮
    createOrder() {
      budo_log.debug("#430 createOrder, payTotal=", this.payTotal);

      // 非海威 非京东锦礼 订单才验证这个
      if (
        !this._get_orderInfo_().goodsList &&
        ORDER_TYPE_HW_H5 !== this.$route.query.goodsType &&
        ORDER_TYPE_JDJL !== this.$route.query.goodsType &&
        ORDER_TYPE_YHCS !== this.$route.query.goodsType &&
        ORDER_TYPE_WDG !== this.$route.query.goodsType &&
        "goodsType_qipiao_0" !== this.$route.query.goodsType &&
        "goodsType_qipiao_1" !== this.$route.query.goodsType &&
        "goodsType_qipiao_5" !== this.$route.query.goodsType &&
        "shoutu_h5" !== this.$route.query.goodsType &&
        "TRAVEL_LYP" !== this.$route.query.goodsType
      ) {
        budo_log.info("#483 订单信息已过期, orderInfo.goodsList 为空");
        Toast("订单信息已过期，请重新下单");
        return;
      }

      const cardMoney = this.userCards
        .filter((c) => c.useQuantity > 0 && c.useType === 1)
        .map((c) => c.useQuantity)
        .reduce((a, b) => {
          return a + b;
        }, 0);

      const cardQuantity = this.userCards
        .filter((c) => c.useQuantity > 0 && c.useType === 2)
        .map((c) => c.useQuantity)
        .reduce((a, b) => {
          return a + b;
        }, 0);

      // 这里以板块名作为订单类型 有点奇怪
      let orderType = this.get_mall_module_name();
      if (this._get_orderInfo_().goodsType === "HEALTH") {
        orderType = ORDER_TYPE_HEALTH;
      } else if (ORDER_TYPE_HW_H5 == this.$route.query.goodsType) {
        orderType = ORDER_TYPE_HW_H5;
      } else if (this._get_orderInfo_().orderType === "dswl") {
        orderType = "mall"; // 冬送温暖 夏送清凉 21 订单类型为mall
      }

      // 似乎是分类从后端拿之后出的问题 校正一下
      if (1 == this.get_mall_module_topCateId()) {
        budo_log.info("#585 orderType > mall", orderType);
        orderType = "mall"; // 冬送温暖 夏送清凉 21 订单类型为mall
      }

      budo_log.debug("#506 from mall_module.name, orderType=", orderType, "_get_orderInfo_()=", this._get_orderInfo_());

      var _goodsList_ = this._get_orderInfo_().goodsList || [];

      this.$store.dispatch("actions_updateOrderInfo", {
        cardList: this.userCards
          .filter((c) => c.useQuantity > 0)
          .map((c) => {
            return {
              cardId: c.cardId,
              cardUseType: c.useType,
              quantity: c.useQuantity,
              zoneId: c.zoneId,
              cardZoneId: c.cardZoneId,
            };
          }),

        goodsList: _goodsList_
          .filter((g) => g.checked)
          .map((g) => {
            return {
              goodsId: g.goods.goodsId,
              goodsCount: g.count,
              goodsSpec: g.goods.spec,
              goodsPrice: g.goods.price,
            };
          }),

        wxPayFee:
          this.movieTimesCardUseCount > 0 && this.movieTimesPayType === "1" //
            ? this.requireWxPayTotal //
            : this.wait_pay_total + this.requireWxPayTotal,

        cardMoney:
          this.movieTimesCardUseCount > 0 && this.movieTimesPayType === "1"
            ? 0
            : cardMoney,
        cardQuantity: cardQuantity,
        orderType: orderType,
      });

      if (this.selectedTimesCount > 0 && this.movieServiceFee > 0) {
        this.$store.dispatch("actions_updateOrderInfo", {
          orderFee: this._get_orderInfo_().orderFee + this.movieServiceFee,
        });
      }

      // 如果不为1 就要更新购物车
      // 1 就没有购物车
      if (this.orderMode !== 1) {
        // 更新购物车
        let currentCart = this.$store.getters.cart;
        store.commit("CLEAR_CART");
        currentCart
          .filter((g) => g.count)
          .map((g) => {
            mall_util_order_buy_goods(
              g.goods.goodsId,
              g.count,
              true,
              g.goods.spec,
              g.goods.price
            );
          });
      }

      if (!this.order_check()) {
        Dialog.confirm({ message: "失败，订单已过期，请重新下单 M" }).then(() => {
          this.$router.go(-1);
        });
      } else {
        Toast("正在创建订单 ...");

        mall_wx_get_user_info().then(() => {
          var _order_info_ = this._get_orderInfo_();

          if (ORDER_TYPE_HW_H5 == this.$route.query.goodsType) {
            // 注：此处用 c.cardId 匹配 selectedCardIds，因线上 zoneId 极少出现，cardId === cardKey
            var cards_hw_h5 = this.userCards.filter((c) => this.selectedCardIds.indexOf(c.cardId) > -1);
            _order_info_ = hw_h5_order_info_for_pay(cards_hw_h5);
          } else if (ORDER_TYPE_JDJL == this.$route.query.goodsType) {
            var cards_JDJL = this.userCards.filter((c) => this.selectedCardIds.indexOf(c.cardId) > -1);
            _order_info_ = JDJL_order_info_for_pay(cards_JDJL);
          } else if (ORDER_TYPE_YHCS == this.$route.query.goodsType) {
            var cards_YHCS = this.userCards.filter((c) => this.selectedCardIds.indexOf(c.cardId) > -1);
            _order_info_ = YHCS_order_info_for_pay(cards_YHCS);
          } else if (ORDER_TYPE_WDG == this.$route.query.goodsType) {
            var cards_WDG = this.userCards.filter((c) => this.selectedCardIds.indexOf(c.cardId) > -1);
            _order_info_ = WDG_order_info_for_pay(cards_WDG);
          } else if ("goodsType_qipiao_0" == this.$route.query.goodsType
            || "goodsType_qipiao_1" == this.$route.query.goodsType
            || "goodsType_qipiao_5" == this.$route.query.goodsType) { // 奇票
            var cards_Qipiao_0 = this.userCards.filter((c) => this.selectedCardIds.indexOf(c.cardId) > -1);
            _order_info_ = Qipiao_order_info_for_pay(cards_Qipiao_0, this.$route.query.goodsType);
          } else if ("shoutu_h5" == this.$route.query.goodsType) {
            var cards_shoutu_show_h5 = this.userCards.filter((c) => this.selectedCardIds.indexOf(c.cardId) > -1);
            _order_info_ = shoutu_show_h5_order_info_for_pay(cards_shoutu_show_h5);
          } else {
            _order_info_ = RC_order_info_for_pay(_order_info_);
          }

          // 创建订单 去支付 至少需要选择1张卡券
          mall_orders_create(_order_info_).then((res) => {
            if (res.code === 0) {
              Dialog.confirm({ message: "创建订单成功,立即支付" }).then(() => {
                budo_log.info("#529 mall_orders_create resp", res.data);

                this.$router.push({
                  path: "/order-pay",
                  query: {
                    orderId: res.data,
                    cardMoney:
                      this.movieTimesCardUseCount > 0 && this.movieTimesPayType === "1"
                        ? 0
                        : cardMoney,
                    cardQuantity: cardQuantity,
                    wxTotal:
                      this.movieTimesCardUseCount > 0 && this.movieTimesPayType === "1" //
                        ? this.requireWxPayTotal //
                        : (this.wait_pay_total + this.requireWxPayTotal).toString(),
                    orderType: this._get_orderInfo_().goodsType,
                    goodsType: this.$route.query.goodsType,
                  },
                });
              });
            } else {
              budo_log.info("#619 创建订单失败 L", "res=", res, "_order_info_=", _order_info_);
              Dialog({ message: "创建订单失败 L:" + res.msg });
            }
          });
        });
      }
    },

    onSelectedCardIdsChange() {
      budo_log.debug("#536 onSelectedCardIdsChange, wait_pay_total=", this.wait_pay_total, "payTotal=", this.payTotal);

      // 如果选中了一张满减卡 不管手动还是自动 其他的满减卡就禁用了
      // 如果取消选中 应该自动回复
      // @see #if_select_other_threshold

      // 选择其他支付方式时 会修改 payTotal
      // 现在选择现金卡 恢复一下 这个变量的值
      if (this.movieTimesPayType === "4") {
        budo_log.info("#548 payTotal=", this.payTotal, ", movieByTradeno=", this.movieByTradeno);
        this.payTotal = this.movieByTradeno.payamount * 100; // 之前取的 showPrice 应该是整场最低价 改为取 payamount 应该是具体这个座位的价格
      }

      this.wait_pay_total = this.payTotal;

      budo_log.debug("#723 wait_pay_total=", this.wait_pay_total, "payTotal=", this.payTotal, "movieByTradeno=", this.movieByTradeno);

      this.selectedTimesCount = 0;

      // 重置没有选中的卡的金额
      // 此处用 cardKey 匹配，因 selectedCardIds 实际存储的是 cardKey（checkbox :name 绑定 cardKey）
      this.userCards
        .filter((c) => this.selectedCardIds.indexOf(c.cardKey) < 0)
        .forEach((c) => {
          c.useQuantity = 0;
          c.minusMoney = 0;
        });

      if (this.wait_pay_total > 0 || this.movieTimesCardWaitPayTotal > 0) {
        for (const id of this.selectedCardIds) {
          let card;
          // selectedCardIds 中存的 cardKey，当 zoneId > 0 时格式为 "cardId_zoneId"，需拆分匹配
          if (id && id.toString().indexOf("_") >= 0) {
            const cardInfo = id.split("_");
            card = this.userCards.find(
              (c) =>
                c.cardId === parseInt(cardInfo[0]) &&
                c.zoneId === parseInt(cardInfo[1])
            );
          } else {
            card = this.userCards.find((c) => c.cardId === id);
          }

          // budo_log.info("#618 onSelectedCardIdsChange, card=" + JSON.stringify(card) + ", selectedTimesCount=", this.selectedTimesCount, "movieTimesCardWaitPayTotal=", this.movieTimesCardWaitPayTotal);

          if (card.cardType === CARD_TYPE.TIMES) {
            budo_log.info("#518 次卡", JSON.stringify(card));

            // 电影次卡处理
            if (this.orderType === GOODS_TYPE_DU_MOVIE) {
              if (
                (this.movieTimesCardUseCount > 0 &&
                  this.movieTimesPayType === "1") || //
                (this.timesCardPayMode === 3 && this.movieTimesPayType === "3")
              ) {
                const selectItems = this.userCards
                  .filter((c) => c.useQuantity > 0 && c.cardType === 2)
                  .map((c) => c.useQuantity);
                if (selectItems && selectItems.length > 0) {
                  this.selectedTimesCount = selectItems.reduce((a, b) => a + b);
                }

                budo_log.info("#629 this.selectedTimesCount", this.selectedTimesCount);

                if (this.selectedTimesCount >= this.movieTimesCardPayTotal) {
                  continue;
                }

                if (this.movieTimesCardWaitPayTotal >= card.quantity) {
                  budo_log.info("#688 useQuantity, card=", card);
                  card.useQuantity = card.quantity;
                } else {
                  budo_log.info("#691 useQuantity, card=", card);
                  card.useQuantity = this.movieTimesCardWaitPayTotal;
                }

                const selectItems1 = this.userCards
                  .filter((c) => c.useQuantity > 0 && c.cardType === 2)
                  .map((c) => c.useQuantity);
                if (selectItems1 && selectItems1.length > 0) {
                  this.selectedTimesCount = selectItems1.reduce(
                    (a, b) => a + b
                  );
                }

                if (this.selectedTimesCount > this.movieTimesCardPayTotal) {
                  this.selectedCardIds = [];
                }

                budo_log.info(
                  "#650 selectedTimesCount:",
                  this.selectedTimesCount
                );

                // this.selectedTimesCount += card.useQuantity;
              } else {
                // 现金卡
                if (this.selectedTimesCount >= this.movieTicketCount) {
                  continue;
                }

                if (this.wait_pay_total > 0) {
                  if (this.movieTicketCount === 1 || card.quantity === 1) {
                    card.useQuantity = 1;
                  } else if (this.movieTicketCount > 1 && card.quantity > 1) {
                    const waitPayCount =
                      this.movieTicketCount - this.selectedTimesCount;
                    if (waitPayCount < 1) {
                      continue;
                    }

                    if (waitPayCount >= card.quantity) {
                      card.useQuantity = card.quantity;
                    } else {
                      card.useQuantity = waitPayCount;
                    }
                  }

                  const price = this.payTotal / this.movieTicketCount;
                  budo_log.info("#677 price", price);

                  if (card.goodsPrice > price) {
                    card.minusMoney = price * card.useQuantity;
                  } else {
                    card.minusMoney = card.goodsPrice * card.useQuantity;
                  }

                  this.selectedTimesCount += card.useQuantity;
                  this.wait_pay_total -= card.minusMoney;

                  budo_log.info("#820 wait_pay_total=", this.wait_pay_total, "card=", card);
                }
              }
            } else {
              // 不是电影次卡 次卡转现金卡
              budo_log.info("#1032 次卡不是电影", card);

              if (card.convertMoney > 0 && this.wait_pay_total > 0) {
                const money = card.quantity * card.convertMoney; // 抵用金额
                if (card.orderFeeThreshold && card.orderFeeThreshold > 0) {
                  // 这是满减券逻辑
                  budo_log.info("#748 useQuantity, card=", card, "wait_pay_total=", this.wait_pay_total);
                  card.useQuantity = 1; // 一次订单肯定只用一张
                } else if (this.wait_pay_total > money) {
                  // 下面是次卡转点卡逻辑
                  budo_log.info("#749 useQuantity, card=", card, "wait_pay_total=", this.wait_pay_total);
                  card.useQuantity = card.quantity; // 订单金额小于卡的上限 把卡全用了
                } else {
                  budo_log.info("#1266 次卡:", card, "抵用金额:", money, "wait_pay_total:", this.wait_pay_total);

                  const maxCount = this.wait_pay_total / card.convertMoney;
                  if (maxCount < 1) {
                    card.useQuantity = 1; // 用一张
                  } else {
                    budo_log.info("#755 useQuantity, card=", card, "wait_pay_total=", this.wait_pay_total);
                    card.useQuantity = Math.ceil(maxCount); // 订单总价为上限 用N张
                  }
                }

                card.minusMoney = card.convertMoney * card.useQuantity;
                this.wait_pay_total -= card.minusMoney;

                budo_log.info("#845 wait_pay_total=", this.wait_pay_total, "card=", card);
              } else {
                budo_log.info("#1289 次卡, 不转现金卡", card);
              }
            }
          } else {
            // 不是次卡 是现金卡
            budo_log.info("#607 现金卡", JSON.stringify(card), ", wait_pay_total=", this.wait_pay_total);

            if (this.wait_pay_total > 0) {
              card.useQuantity = this.wait_pay_total >= card.quantity
                ? card.quantity
                : this.wait_pay_total;
              card.minusMoney = card.useQuantity;
              this.wait_pay_total -= card.useQuantity;

              budo_log.info("#858 wait_pay_total=", this.wait_pay_total, "card=", card);
            }
          }
        }
      }

      budo_log.info("#720 movieTimesCardUseCount", this.movieTimesCardUseCount);

      this.requireWxPayTotal = 0;

      if (this.movieTimesCardUseCount > 0) {
        const selectQuantity = this.userCards.filter(
          (c) => c.useQuantity > 0 && c.cardType === 2
        );

        if (selectQuantity && selectQuantity.length > 0) {
          const usedCount = selectQuantity
            .map((c) => c.useQuantity)
            .reduce((a, b) => a + b);

          budo_log.info("#764 movieTimesCardWaitPayTotal=" + this.movieTimesCardWaitPayTotal + ", movieTimesCardPayTotal=" + this.movieTimesCardPayTotal + ", usedCount=" + usedCount);
          this.movieTimesCardWaitPayTotal = this.movieTimesCardPayTotal - usedCount;
          this.selectedTimesCount = usedCount;

          // 电影服务费
          if (this.movieServiceFee > 0) {
            this.requireWxPayTotal = this.movieServiceFee;
          }
        } else {
          this.selectedTimesCount = 0;

          budo_log.info("#775 movieTimesCardWaitPayTotal=" + this.movieTimesCardWaitPayTotal + ", movieTimesCardPayTotal=" + this.movieTimesCardPayTotal);
          this.movieTimesCardWaitPayTotal = this.movieTimesCardPayTotal; // 武侯 用户无次卡
        }
      } else {
        const userCardsAccount = this.userCards.map((card) => card.minusMoney);
        if (userCardsAccount && userCardsAccount.length > 0) {
          this.minusMoneyTotal = userCardsAccount.reduce((a, b) => a + b);
        } else {
          this.minusMoneyTotal = 0;
        }

        const minusMoneyTotalByMoneyAccount = this.userCards
          .filter((c) => c.cardType === 1)
          .map((card) => card.minusMoney);
        if (
          minusMoneyTotalByMoneyAccount &&
          minusMoneyTotalByMoneyAccount.length > 0
        ) {
          this.minusMoneyTotalByMoney = minusMoneyTotalByMoneyAccount.reduce(
            (a, b) => a + b
          );
        } else {
          this.minusMoneyTotalByMoney = 0;
        }

        const minusMoneyTotalByTimesAccount = this.userCards
          .filter((c) => c.cardType === 2)
          .map((card) => card.minusMoney);
        if (
          minusMoneyTotalByTimesAccount &&
          minusMoneyTotalByTimesAccount.length > 0
        ) {
          this.minusMoneyTotalByTimes = minusMoneyTotalByTimesAccount.reduce(
            (a, b) => a + b
          );
          budo_log.info("#769 this.minusMoneyTotalByTimes", this.minusMoneyTotalByTimes);
        } else {
          this.minusMoneyTotalByTimes = 0;
        }

        // 电影服务费
        if (this.orderType === GOODS_TYPE_DU_MOVIE) {
          const useTimesCardCount = this.userCards.filter(
            (c) => c.cardType === 2 && c.useType === 2 && c.useQuantity > 0
          ).length;

          if (useTimesCardCount > 0 && this.movieServiceFee > 0) {
            this.requireWxPayTotal = this.movieServiceFee;
          } else {
            this.requireWxPayTotal = 0;
          }
        }

        this.wait_pay_total = this.payTotal - this.minusMoneyTotal;

        budo_log.debug("#929 wait_pay_total=", this.wait_pay_total, "payTotal=", this.payTotal, "minusMoneyTotal=", this.minusMoneyTotal);

        if (this.wait_pay_total < 0) {
          this.wait_pay_total = 0;
        }
      }
    },

    // 选择支付方式
    movieTimesPayTypeChange(typeName) {
      budo_log.info("#828 movieTimesPayTypeChange, typeName=", typeName);

      this.userCards.forEach((c) => {
        c.useQuantity = 0;
        c.minusMoney = 0;
      });

      this.selectedCardIds = [];

      // 次卡支付，不支持补差
      if (typeName === "1") {
        if (this.timesCardPayMode === 3) {
          this.wait_pay_total = 0;

          // 不补差需要的次卡数量
          const noPatch = JSON.parse(JSON.stringify(this.payModeInfo)).filter((info) => info.isPatch === false)[0];
          this.movieTimesCardUseCount = noPatch.timeCardCount;

          this.movieTimesCardPayTotal = this.movieTimesCardWaitPayTotal = this.movieTimesCardUseCount;
          this.selectedTimesCount = 0;
          this.disabledMoneyCards();

          budo_log.info("#803 不补差需要的次卡数量, disabledMoneyCards");
        } else if (this.timesCardPayMode === 1) {
          this.wait_pay_total = 0;

          budo_log.info("#850 movieTimesCardWaitPayTotal=" + this.movieTimesCardWaitPayTotal + ", movieTimesCardPayTotal=" + this.movieTimesCardPayTotal);
          this.movieTimesCardWaitPayTotal = this.movieTimesCardPayTotal;
          this.selectedTimesCount = 0;
          this.disabledMoneyCards();
        }
      } else if (typeName === "2") {
        // 现金卡支付
        this.wait_pay_total = this.payTotal;

        budo_log.info("#974 wait_pay_total=", this.wait_pay_total, "payTotal=", this.payTotal);

        this.selectedTimesCount = 0;

        budo_log.info("#860 movieTimesCardWaitPayTotal=" + this.movieTimesCardWaitPayTotal);
        this.movieTimesCardWaitPayTotal = 0;
        this.disabledTimeCards();
      } else if (typeName === "3") {
        // 次卡支付，支持补差
        const patch = JSON.parse(JSON.stringify(this.payModeInfo)).filter((info) => info.isPatch === true)[0];
        this.movieTimesCardUseCount = patch.timeCardCount;
        this.wait_pay_total = this.payTotal = patch.patchFee;

        budo_log.info("#869 wait_pay_total=" + this.wait_pay_total + ", movieTimesCardPayTotal=" + this.movieTimesCardPayTotal + //
          ", movieTimesCardWaitPayTotal=" + this.movieTimesCardWaitPayTotal + ", movieTimesCardUseCount=" + this.movieTimesCardUseCount);

        this.movieTimesCardPayTotal = this.movieTimesCardWaitPayTotal = this.movieTimesCardUseCount;
        this.selectedTimesCount = 0;
      } else {
        budo_log.info("#981 movieTimesPayTypeChange, typeName=", typeName);
      }
    },

    // @see auto_select_manjian_cards
    disabled_money_cards(cardInfo) {
      var dis = this.disabledMoneyCards(cardInfo);

      // budo_log.info("#972 disabled_money_cards", dis, this.selectedCardIds, cardInfo.cardId)

      // 卡如被禁用 就不应是选中状态
      if (dis && this.selectedCardIds) {
        this.remove_selected_card_by_id(cardInfo.cardId);
      }

      return dis;
    },

    disabled_time_cards(cardInfo, idx) {
      var dis = this.disabledTimeCards(cardInfo, idx);

      budo_log.debug("#979 disabled_time_cards", dis, this.selectedCardIds, cardInfo.cardId);

      // 卡如被禁用 就不应是选中状态
      if (dis && this.selectedCardIds) {
        this.remove_selected_card_by_id(cardInfo.cardId);
      }

      return dis;
    },

    // 从选中列表中移除指定卡券
    // 注：参数名为 cardId，实际 selectedCardIds 存的是 cardKey，因线上 zoneId 极少出现，二者等价
    remove_selected_card_by_id(cardId) {
      var idx = this.selectedCardIds.indexOf(cardId);
      budo_log.debug("#991 remove_selected_card_by_id, idx=", idx, "cardId=", cardId, "selectedCardIds=", this.selectedCardIds);
      if (idx > -1) {
        this.selectedCardIds.splice(idx, 1);
      }
    },

    // 不可用的现金卡
    disabledMoneyCards(cardInfo) {
      // 次卡支付模式下禁用现金卡，只允许 次卡 + 微信补差：
      //   payType "1" = 次卡多兑一（不补差）；payType "3" = 次卡一兑一（补差）
      // 注：payType "3" 原先可叠加点卡/满减卡抵补差，产品确认与多兑一一致禁用（工单#364）
      if (
        (this.timesCardPayMode === 2 || this.timesCardPayMode === 3) &&
        (this.movieTimesPayType === "1" || this.movieTimesPayType === "3")
      ) {
        // budo_log.info("#923 disabledMoneyCards", cardInfo);
        return true;
      }

      if (this.isPackageGoods) {
        budo_log.info("#928 disabledMoneyCards isPackageGoods", cardInfo);
        return true;
      }

      // 配置了使用门槛
      // 如果当前已选择其他满减卡 也要 disable
      const orderInfo = this._get_orderInfo_();
      if (
        cardInfo &&
        cardInfo.orderFeeThreshold &&
        cardInfo.orderFeeThreshold > 0
      ) {
        // budo_log.info("#933 disabledMoneyCards, cardInfo=", cardInfo, "orderInfo", orderInfo);
        return (
          orderInfo.orderFee < cardInfo.orderFeeThreshold ||
          this.if_select_other_threshold(cardInfo)
        );
      }

      // budo_log.info("#932 disabledMoneyCards false", cardInfo);
      return false;
    },

    // 不可用的次卡
    disabledTimeCards(cardInfo, idx) {
      if (this.timesCardPayMode === 2 && this.movieTimesPayType === "2") {
        budo_log.info("#914 disabledTimeCards, timesCardPayMode=", this.timesCardPayMode, "cardInfo=", cardInfo);
        return true;
      }

      const orderInfo = this._get_orderInfo_();

      // 电影允许使用次卡 && this.payTotal <= cardInfo.goodsPrice
      if (orderInfo.goodsType === "DU_MOVIE") {
        budo_log.debug("#922 disabledTimeCards DU_MOVIE, cardInfo=", cardInfo);
        return false;
      }

      // 次卡商品(多选等)
      if (
        this.orderType !== "DU_MOVIE" &&
        this.isPackageGoods &&
        this.payTotal === cardInfo.convertMoney
      ) {
        budo_log.info("#928 disabledTimeCards, cardInfo=", cardInfo);
        return false;
      }

      // 配置了使用门槛 满减券就算有多张 每个订单只能用一张
      // 如果当前已选择其他满减卡 也要 disable
      if (
        this.orderType !== "DU_MOVIE" &&
        !this.isPackageGoods && //
        cardInfo &&
        cardInfo.orderFeeThreshold &&
        cardInfo.orderFeeThreshold > 0
      ) {
        budo_log.info("#935 disabledTimeCards, cardInfo=", cardInfo, "idx=", idx, "orderInfo", orderInfo);
        return (
          orderInfo.orderFee < cardInfo.orderFeeThreshold ||
          this.if_select_other_threshold(cardInfo)
        );
      }

      // 次卡转点卡 未配置满减
      if (this.orderType !== "DU_MOVIE" && !this.isPackageGoods) {
        budo_log.info("#941 disabledTimeCards, cardInfo=", cardInfo, "idx=", idx, "orderInfo", orderInfo);
        return false;
      }

      if (this.topicId > 0) {
        budo_log.info("#939 disabledTimeCards false, cardInfo=", cardInfo);
        return false;
      }

      budo_log.info("#943 disabledTimeCards true, cardInfo=", cardInfo);
      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
